import { render, staticRenderFns } from "./create-or-edit-purchase.vue?vue&type=template&id=62fc6158"
import script from "./create-or-edit-purchase.ts?vue&type=script&lang=js&external"
export * from "./create-or-edit-purchase.ts?vue&type=script&lang=js&external"
import style0 from "./create-or-edit-purchase.vue?vue&type=style&index=0&id=62fc6158&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports